import { apiClient } from '../config';
import { endpoints } from '../endpoints';

/**
 * Notification service for handling notification preferences
 */
export const notificationService = {
  /**
   * Get user's notification preferences
   * @returns {Promise<Object>} - Promise resolving to notification preferences
   */
  getNotificationPreferences: async () => {
    const response = await apiClient.get(endpoints.notifications.preferences.get);
    return response.data;
  },

  /**
   * Update user's notification preferences
   * @param {Object} preferences - Notification preferences to update
   * @param {boolean} preferences.emailNotifications - Whether to receive email notifications
   * @param {boolean} preferences.reviewRequests - Whether to receive review request notifications
   * @param {boolean} preferences.manuscriptUpdates - Whether to receive manuscript update notifications
   * @param {boolean} preferences.newsletterSubscription - Whether to receive newsletter
   * @returns {Promise<Object>} - Promise resolving to updated notification preferences
   */
  updateNotificationPreferences: async (preferences) => {
    const response = await apiClient.put(endpoints.notifications.preferences.update, preferences);
    return response.data;
  }
};
